import { css } from '@emotion/css';
import { colors } from 'constants/theme';

/* Bảng màu sáng, lấy theo nền sẵn có của trang tài khoản (#f5f6fb) và thẻ trắng. */
const SURFACE = '#ffffff';
const LINE = '#e4e8f2';
const LINE_SOFT = '#eef1f7';
const FIELD = '#f5f7fc';
const INK = '#1a2340';
const INK_MUTE = '#6b7590';
const BRAND = '#011e98';
const BRAND_LIGHT = '#1b53f0';
const ACCENT_BLUE = 'linear-gradient(180deg, #1b53f0, #011e98)';
const DANGER = '#d92b28';
const SHADOW = '0 2px 10px rgba(20, 35, 90, 0.07)';
const SHADOW_LIFT = '0 10px 26px rgba(20, 35, 90, 0.14)';

const fundTransferStyle = {
    wrap: css`
        display: flex;
        flex-direction: column;
        gap: 10px;
    `,

    /* ---------- Thẻ tổng quan số dư ---------- */
    balanceMain: css`
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 11px 16px;
        border-radius: 12px;
        background: linear-gradient(115deg, ${BRAND_LIGHT} 0%, ${BRAND} 100%);
        box-shadow: ${SHADOW_LIFT};
        &::after {
            content: '';
            position: absolute;
            top: -80%;
            right: -6%;
            width: 220px;
            height: 220px;
            border-radius: 50%;
            background: radial-gradient(circle, rgba(255, 255, 255, 0.18) 0%, transparent 70%);
            pointer-events: none;
        }
        @media (max-width: 560px) {
            gap: 12px;
            padding: 10px 12px;
        }
    `,
    balanceBlock: css`
        position: relative;
        z-index: 1;
        flex: 1;
        min-width: 0;
    `,
    balanceLabel: css`
        display: block;
        font-size: 11px;
        color: rgba(255, 255, 255, 0.75);
        margin-bottom: 1px;
    `,
    balanceValueMain: css`
        display: block;
        font-size: 21px;
        font-weight: 800;
        line-height: 1.2;
        color: ${colors.secondary};
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @media (max-width: 560px) {
            font-size: 18px;
        }
    `,
    balanceValueSub: css`
        display: block;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.2;
        color: ${colors.white};
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
    balanceDivider: css`
        width: 1px;
        align-self: stretch;
        background: rgba(255, 255, 255, 0.25);
    `,
    btnRefreshAll: css`
        position: relative;
        z-index: 1;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 7px 12px;
        border-radius: 8px;
        border: 1px solid rgba(255, 255, 255, 0.35);
        background: rgba(255, 255, 255, 0.14);
        color: ${colors.white};
        font-size: 13px;
        font-weight: 600;
        white-space: nowrap;
        cursor: pointer;
        transition: background 0.2s ease, transform 0.15s ease;
        &:hover {
            background: rgba(255, 255, 255, 0.26);
        }
        &:active {
            transform: scale(0.97);
        }
        &:disabled {
            opacity: 0.55;
            pointer-events: none;
        }
        span {
            @media (max-width: 560px) {
                display: none;
            }
        }
    `,

    /* ---------- Lưới ví game ---------- */
    gameWrap: css`
        padding: 12px;
        border-radius: 12px;
        border: 1px solid ${LINE};
        background: ${SURFACE};
        box-shadow: ${SHADOW};
    `,
    gameGroup: css`
        margin-bottom: 14px;
        &:last-child {
            margin-bottom: 0;
        }
    `,
    gameGroupTitle: css`
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.02em;
        color: ${BRAND};
        &::after {
            content: '';
            flex: 1;
            height: 1px;
            background: ${LINE_SOFT};
        }
    `,
    gameList: css`
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(176px, 1fr));
        gap: 8px;
    `,

    /* ---------- Bảng chuyển quỹ (trong Modal) ---------- */
    panel: css`
        width: 100%;
        max-height: calc(100vh - 32px);
        overflow-y: auto;
        padding: 16px;
        border-radius: 14px;
        background: ${SURFACE};
        box-shadow: 0 24px 60px rgba(12, 22, 60, 0.3);
        color: ${INK};
    `,
    heading: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding-bottom: 10px;
        margin-bottom: 14px;
        border-bottom: 1px solid ${LINE_SOFT};
    `,
    title: css`
        font-size: 17px;
        font-weight: 800;
        color: ${INK};
    `,
    btnClose: css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 1px solid ${LINE};
        background: ${FIELD};
        color: ${INK_MUTE};
        cursor: pointer;
        transition: background 0.2s ease, color 0.2s ease;
        &:hover {
            background: #e8ecf6;
            color: ${INK};
        }
    `,

    /* Sơ đồ hướng chuyển: Nguồn -> [đảo chiều] -> Đích */
    route: css`
        display: flex;
        align-items: stretch;
        gap: 8px;
        margin-bottom: 14px;
    `,
    routeCard: css`
        flex: 1;
        min-width: 0;
        padding: 9px 12px;
        border-radius: 10px;
        border: 1px solid ${LINE};
        background: ${FIELD};
    `,
    routeRole: css`
        display: block;
        font-size: 11px;
        color: ${INK_MUTE};
        margin-bottom: 3px;
    `,
    routeName: css`
        display: block;
        font-size: 14px;
        font-weight: 700;
        color: ${INK};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 1px;
    `,
    routeBalance: css`
        display: block;
        font-size: 12.5px;
        font-weight: 700;
        color: ${BRAND};
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
    btnSwap: css`
        align-self: center;
        flex: 0 0 auto;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 0;
        background: ${ACCENT_BLUE};
        color: ${colors.white};
        cursor: pointer;
        box-shadow: 0 6px 16px rgba(27, 83, 240, 0.35);
        transition: transform 0.25s ease;
        &:hover {
            transform: rotate(180deg);
        }
        &:active {
            transform: rotate(180deg) scale(0.92);
        }
    `,

    field: css`
        margin-bottom: 12px;
    `,
    label: css`
        display: block;
        font-size: 12px;
        font-weight: 700;
        color: ${INK_MUTE};
        margin-bottom: 6px;
    `,
    selectWrap: css`
        position: relative;
        svg {
            position: absolute;
            top: 50%;
            right: 14px;
            transform: translateY(-50%);
            pointer-events: none;
            color: ${INK_MUTE};
        }
    `,
    select: css`
        width: 100%;
        appearance: none;
        padding: 12px 38px 12px 14px;
        border-radius: 10px;
        border: 1px solid ${LINE};
        background: ${FIELD};
        color: ${INK};
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: border-color 0.2s ease, background 0.2s ease;
        &:hover {
            background: #eef2fb;
        }
        &:focus {
            outline: none;
            border-color: ${BRAND_LIGHT};
            background: ${SURFACE};
        }
        option:disabled {
            color: #a3aabf;
        }
    `,

    amountBox: css`
        display: flex;
        align-items: center;
        border-radius: 10px;
        border: 1px solid ${LINE};
        background: ${FIELD};
        transition: border-color 0.2s ease, background 0.2s ease;
        &:focus-within {
            border-color: ${BRAND_LIGHT};
            background: ${SURFACE};
            box-shadow: 0 0 0 3px rgba(27, 83, 240, 0.12);
        }
    `,
    amountInput: css`
        flex: 1;
        min-width: 0;
        padding: 10px 12px;
        border: 0;
        background: transparent;
        color: ${INK};
        font-size: 19px;
        font-weight: 800;
        font-variant-numeric: tabular-nums;
        &::placeholder {
            color: #aab2c8;
            font-weight: 600;
            font-size: 16px;
        }
        &:focus {
            outline: none;
        }
    `,
    amountUnit: css`
        padding-right: 12px;
        font-size: 13px;
        font-weight: 700;
        color: ${INK_MUTE};
    `,
    amountInvalid: css`
        border-color: ${DANGER} !important;
        box-shadow: 0 0 0 3px rgba(217, 43, 40, 0.1) !important;
    `,

    chipRow: css`
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 6px;
        margin-top: 8px;
    `,
    chip: css`
        padding: 7px 0;
        border-radius: 8px;
        border: 1px solid ${LINE};
        background: ${SURFACE};
        color: ${INK};
        font-size: 12.5px;
        font-weight: 700;
        cursor: pointer;
        transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease, transform 0.12s ease;
        &:hover {
            border-color: ${BRAND_LIGHT};
            color: ${BRAND};
            background: #f3f6ff;
        }
        &:active {
            transform: scale(0.96);
        }
        &:disabled {
            opacity: 0.4;
            pointer-events: none;
        }
    `,
    chipActive: css`
        background: ${ACCENT_BLUE} !important;
        border-color: ${BRAND} !important;
        color: ${colors.white} !important;
    `,
    chipMax: css`
        color: ${BRAND};
    `,

    hintRow: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin-top: 7px;
        font-size: 11.5px;
        color: ${INK_MUTE};
    `,
    errorText: css`
        display: flex;
        align-items: center;
        gap: 6px;
        margin-top: 7px;
        font-size: 12px;
        font-weight: 700;
        color: ${DANGER};
    `,

    convertBox: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 9px 12px;
        margin-bottom: 12px;
        border-radius: 10px;
        border: 1px dashed #c9d3ee;
        background: #f3f6ff;
        font-size: 12px;
        color: ${INK_MUTE};
    `,
    convertValue: css`
        font-weight: 800;
        color: ${BRAND};
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
    `,

    btnSubmit: css`
        width: 100%;
        padding: 12px 0;
        border-radius: 10px;
        border: 0;
        font-size: 14px;
        font-weight: 800;
        letter-spacing: 0.04em;
        color: ${colors.white};
        cursor: pointer;
        background: ${ACCENT_BLUE};
        box-shadow: 0 8px 20px rgba(27, 83, 240, 0.32);
        transition: filter 0.2s ease, transform 0.12s ease;
        &:hover {
            filter: brightness(1.1);
        }
        &:active {
            transform: scale(0.99);
        }
        &:disabled {
            background: #e6e9f2;
            box-shadow: none;
            color: #a3aabf;
            pointer-events: none;
        }
    `,
};

export default fundTransferStyle;
